module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-2-8a4261179ee4540b06db64b4a701a246.jpg";